var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeoffIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#2D3D95",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322 2238 l-72 -73 146 -146 146 -146 -104 -104 c-114 -113 -228 -274 -294 -412 l-37 -78 42 -85 c172 -346 445 -597 773 -710 265 -91 624 -63 881 67 l40 21 161 -161 161 -161 73 73 72 72 -958 958 -957 957 -73 -72z m481 -631 l105 -112 -25 -75 c-95 -282 106 -564 402 -562 40 0 90 10 140 27 l79 26 88 -88 c48 -48 88 -90 88 -93 0 -7 -104 -46 -180 -66 -103 -28 -349 -25 -459 4 -180 49 -329 140 -468 286 -83 86 -174 210 -217 294 -17 33 -17 34 15 90 60 107 110 173 212 278 56 57 105 104 108 104 4 0 54 -51 112 -113z m490 -535 c-133 -9 -223 76 -223 210 l0 63 135 -135 135 -135 -47 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105 2119 c-32 -5 -84 -16 -114 -25 l-54 -16 81 -81 82 -82 168 0 c186 -1 268 -16 397 -74 170 -77 354 -240 467 -413 97 -146 95 -139 54 -211 -36 -64 -80 -128 -130 -192 l-29 -36 74 -75 74 -75 28 33 c51 61 175 252 214 331 l38 78 -45 87 c-219 429 -572 702 -974 752 -94 12 -246 11 -331 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505 1510 c105 -105 191 -186 193 -180 2 5 -4 36 -13 67 -29 99 -84 176 -164 230 -51 34 -152 73 -189 73 -10 0 67 -83 173 -190z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoffIcon);
export default __webpack_public_path__ + "static/media/eyeoff-icon.4163254b562fd3f2ef3218152b840a64.svg";
export { ForwardRef as ReactComponent };